/* eslint-disable no-unused-vars */
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '@/store/index';
import { clearUserData } from '@/services/auth';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: routes,
  linkActiveClass: 'is-active'
});

function isRoleSufficent(item) {
  if (store.state.user.current.role === item.role) {
    return true;
  }

  if (store.state.user.current.role === 'admin' && item.role === 'user') {
    return true;
  }

  if (store.state.user.current.role === 'superadmin') {
    return true;
  }

  return false;
}

/**
 * Process for each route to check for authentification and redirection
 * @param  {Object} to
 * @param  {Object} from
 * @param  {Function} next
 * @return {void}
 */
router.beforeEach((to, from, next) => {
  const IS_AUTHENTICATED = localStorage.getItem('token');

  // ToDO: Redirect user to login page if not authenticated
  if (to.meta.auth) {
    // ToDo: Improve! Currently we need to wait until user data has been loaded.
    // After that we can compare user role and minimum navigation role
    // if (store.state.user.current.role) {
    //     if (!isRoleSufficent(to.meta)) {
    //         console.log(isRoleSufficent(to.meta), '-----------', to.meta);
    //         next({ path: '/dashboard' });
    //     }
    // }

    if (!IS_AUTHENTICATED) {
      // clearUserData();
      // next({ path: '/login' });
      next();
    } else {
      next();
    }
  } else {
    next();
  }
});

/**
 * Process for each route after entering
 * @param  {Object} to
 * @param  {Object} from
 * @return {void}
 */
router.afterEach((to, from) => {
  // store.commit('SET_SIDEBAR', { visible: false });
});

export default router;
